// @ts-nocheck
/**
 * 素材タイプ定義
 *
 * 素材カテゴリ:
 * - attribute: 属性素材（炎の結晶など）
 * - category: カテゴリ素材（ドラゴンの鱗など）
 * - generic: 汎用素材（魔力の核など）
 * - rarity: レアリティ破片
 * - special: 特殊素材
 */

/**
 * 属性素材
 */
export const ATTRIBUTE_MATERIALS = {
  fire_crystal: {
    id: 'fire_crystal',
    name: '炎の結晶',
    attribute: '炎',
    tier: 'common',
    description: '炎属性の魔力が凝縮した結晶。炎属性装備の素材。',
    icon: '🔥',
  },
  water_crystal: {
    id: 'water_crystal',
    name: '水の結晶',
    attribute: '水',
    tier: 'common',
    description: '水属性の魔力が凝縮した結晶。水属性装備の素材。',
    icon: '💧',
  },
  light_crystal: {
    id: 'light_crystal',
    name: '光の結晶',
    attribute: '光',
    tier: 'common',
    description: '光属性の魔力が凝縮した結晶。光属性装備の素材。',
    icon: '✨',
  },
  dark_crystal: {
    id: 'dark_crystal',
    name: '闇の結晶',
    attribute: '闇',
    tier: 'common',
    description: '闇属性の魔力が凝縮した結晶。闘属性装備の素材。',
    icon: '🌑',
  },
  primal_crystal: {
    id: 'primal_crystal',
    name: '原始の結晶',
    attribute: '原始',
    tier: 'common',
    description: '原始属性の魔力が凝縮した結晶。原始属性装備の素材。',
    icon: '🌿',
  },
  future_crystal: {
    id: 'future_crystal',
    name: '未来の結晶',
    attribute: '未来',
    tier: 'common',
    description: '未来属性の魔力が凝縮した結晶。未来属性装備の素材。',
    icon: '⚡',
  },
};

/**
 * カテゴリ素材
 *
 * crafting_system_design.md に基づく新設計:
 * - 種族系素材 (13グループ): ヒューマノイド, ビースト, スピリット, 鳥, ゴーレム, プラント, スライム, ドラゴン, 虫類, 機械, 魔法生物, 霊体, 爬虫類
 * - 派閥系素材 (15グループ): ソウルカース, タイドウェーブ, パペットマスター, ダークドウェラ, マグマフォージ, 蛮族, エクラシア, 飛翔連合, 深淵勢力, 虚蝕, 聖光, 時空, 毒牙, 拘束, 宿敵
 *
 * 各グループは ノーマル素材 (tier: uncommon) と レア素材 (tier: rare/epic) を持つ
 */
export const CATEGORY_MATERIALS = {
  // ========================================
  // 種族系素材 (13グループ, 27素材)
  // ========================================

  // --- ヒューマノイド系 ---
  humanoid_proof: {
    id: 'humanoid_proof',
    name: '人型の証',
    group: 'humanoid',
    groupType: 'race',
    categories: ['ヒューマノイド', 'カイザー', 'ソルジャー'],
    tier: 'uncommon',
    description: '人型生物から得られる証。武器や防具の素材として使用。',
    icon: '👤',
  },
  hero_soul: {
    id: 'hero_soul',
    name: '英雄の魂',
    group: 'humanoid',
    groupType: 'race',
    categories: ['ヒューマノイド', 'カイザー', 'ソルジャー'],
    tier: 'rare',
    description: '英雄の魂が宿った貴重な素材。強力な装備の核となる。',
    icon: '⚔️',
  },

  // --- ビースト系 ---
  beast_fang: {
    id: 'beast_fang',
    name: '獣の牙',
    group: 'beast',
    groupType: 'race',
    categories: ['ビースト', 'ビースト・猫', 'ビースト・狸', 'ビースト・狼', 'ビースト・フロッグ', 'ビースト・鹿', 'ビースト・イノシシ', '幻獣'],
    tier: 'uncommon',
    description: '野生の獣から採取した牙。武器の素材として優秀。',
    icon: '🦷',
  },
  beast_king_fang: {
    id: 'beast_king_fang',
    name: '獣王の牙',
    group: 'beast',
    groupType: 'race',
    categories: ['ビースト', 'ビースト・猫', 'ビースト・狸', 'ビースト・狼', 'ビースト・フロッグ', 'ビースト・鹿', 'ビースト・イノシシ', '幻獣'],
    tier: 'rare',
    description: '獣の王から得られた希少な牙。強力な武器の核となる。',
    icon: '🦁',
  },

  // --- スピリット系 ---
  spirit_ether: {
    id: 'spirit_ether',
    name: '霊魂のエーテル',
    group: 'spirit',
    groupType: 'race',
    categories: ['スピリット'],
    tier: 'uncommon',
    description: '精霊から採取した純粋なエーテル。魔法装備の素材。',
    icon: '✨',
  },
  spirit_king_tear: {
    id: 'spirit_king_tear',
    name: '精霊王の涙',
    group: 'spirit',
    groupType: 'race',
    categories: ['スピリット'],
    tier: 'rare',
    description: '精霊王が流した涙の結晶。非常に希少な素材。',
    icon: '💧',
  },

  // --- 鳥系 ---
  wind_feather: {
    id: 'wind_feather',
    name: '風切り羽',
    group: 'bird',
    groupType: 'race',
    categories: ['鳥', '鳥・カラス', '鳥・カモメ'],
    tier: 'uncommon',
    description: '風を切る鳥の羽根。軽量装備の素材として使用。',
    icon: '🪶',
  },
  sky_feather: {
    id: 'sky_feather',
    name: '天翔の羽根',
    group: 'bird',
    groupType: 'race',
    categories: ['鳥', '鳥・カラス', '鳥・カモメ'],
    tier: 'rare',
    description: '天空を翔る鳥から得られる希少な羽根。',
    icon: '🦅',
  },

  // --- ゴーレム系 ---
  magic_core: {
    id: 'magic_core',
    name: '魔力のコア',
    group: 'golem',
    groupType: 'race',
    categories: ['ゴーレム', 'ガーディアン'],
    tier: 'uncommon',
    description: 'ゴーレムの核となる魔力の結晶。',
    icon: '🔮',
  },
  ancient_core: {
    id: 'ancient_core',
    name: '古代のコア',
    group: 'golem',
    groupType: 'race',
    categories: ['ゴーレム', 'ガーディアン'],
    tier: 'rare',
    description: '太古のゴーレムから得られる希少なコア。',
    icon: '🗿',
  },

  // --- プラント系 ---
  life_seed: {
    id: 'life_seed',
    name: '生命の種子',
    group: 'plant',
    groupType: 'race',
    categories: ['プラント'],
    tier: 'uncommon',
    description: '植物生物から得られる生命力を持つ種子。',
    icon: '🌱',
  },
  world_tree_drop: {
    id: 'world_tree_drop',
    name: '世界樹の雫',
    group: 'plant',
    groupType: 'race',
    categories: ['プラント'],
    tier: 'rare',
    description: '世界樹から滴り落ちた神聖な雫。',
    icon: '🌳',
  },

  // --- スライム系 ---
  slime_core: {
    id: 'slime_core',
    name: '粘液核',
    group: 'slime',
    groupType: 'race',
    categories: ['スライム', 'コア・ビースト'],
    tier: 'uncommon',
    description: 'スライムの中心にある核。柔軟な素材。',
    icon: '🟢',
  },
  king_slime_core: {
    id: 'king_slime_core',
    name: '王核スライム',
    group: 'slime',
    groupType: 'race',
    categories: ['スライム', 'コア・ビースト'],
    tier: 'rare',
    description: 'スライムの王から得られる巨大な核。',
    icon: '👑',
  },

  // --- ドラゴン系 ---
  dragon_scale: {
    id: 'dragon_scale',
    name: '竜鱗',
    group: 'dragon',
    groupType: 'race',
    categories: ['ドラゴン', 'ワイバーン', 'サラマンダー'],
    tier: 'uncommon',
    description: '竜族の硬質な鱗。防具の素材として優秀。',
    icon: '🐉',
  },
  dragon_king_scale: {
    id: 'dragon_king_scale',
    name: '竜王の逆鱗',
    group: 'dragon',
    groupType: 'race',
    categories: ['ドラゴン', 'ワイバーン', 'サラマンダー'],
    tier: 'epic',
    description: '竜王の逆鱗。触れると災いをもたらすとされる。',
    icon: '🔥',
  },

  // --- 虫類 ---
  insect_shell: {
    id: 'insect_shell',
    name: '虫殻の欠片',
    group: 'insect',
    groupType: 'race',
    categories: ['インセクト', 'インセクト・アリ', 'インセクト・ビートル', 'インセクト・蜘蛛', 'インセクト・蛾', 'インセクト・アメンボ'],
    tier: 'uncommon',
    description: '虫の硬い殻の欠片。軽量な防具の素材。',
    icon: '🐛',
  },
  queen_ant_antenna: {
    id: 'queen_ant_antenna',
    name: '女王蟻の触角',
    group: 'insect',
    groupType: 'race',
    categories: ['インセクト', 'インセクト・アリ', 'インセクト・ビートル', 'インセクト・蜘蛛', 'インセクト・蛾', 'インセクト・アメンボ'],
    tier: 'rare',
    description: '女王蟻から得られる希少な触角。',
    icon: '🐜',
  },

  // --- 機械 ---
  machine_parts: {
    id: 'machine_parts',
    name: '機械部品',
    group: 'machine',
    groupType: 'race',
    categories: ['マシン'],
    tier: 'uncommon',
    description: '精巧な機械の部品。未来装備の素材。',
    icon: '⚙️',
  },
  energy_core: {
    id: 'energy_core',
    name: 'エネルギーコア',
    group: 'machine',
    groupType: 'race',
    categories: ['マシン'],
    tier: 'rare',
    description: '高出力のエネルギー核。強力な機械装備の核となる。',
    icon: '🔋',
  },

  // --- 魔法生物 ---
  magic_crystal: {
    id: 'magic_crystal',
    name: '魔力結晶',
    group: 'magic_creature',
    groupType: 'race',
    categories: ['魔族', '魔導士', 'ウィザード'],
    tier: 'uncommon',
    description: '魔法生物から得られる魔力の結晶。',
    icon: '💎',
  },
  demon_king_horn: {
    id: 'demon_king_horn',
    name: '魔王の角',
    group: 'magic_creature',
    groupType: 'race',
    categories: ['魔族'],
    tier: 'epic',
    description: '魔王から得られる禍々しい角。',
    icon: '😈',
  },
  sage_stone: {
    id: 'sage_stone',
    name: '賢者の石',
    group: 'magic_creature',
    groupType: 'race',
    categories: ['魔導士', 'ウィザード'],
    tier: 'epic',
    description: '賢者が生涯をかけて精製した伝説の石。',
    icon: '🔴',
  },

  // --- 霊体 ---
  grudge_residue: {
    id: 'grudge_residue',
    name: '怨念の残滓',
    group: 'ghost',
    groupType: 'race',
    categories: ['ゴースト', 'スケルトン'],
    tier: 'uncommon',
    description: '霊体から採取した怨念の残滓。闇属性装備の素材。',
    icon: '👻',
  },
  underworld_light: {
    id: 'underworld_light',
    name: '冥界の灯火',
    group: 'ghost',
    groupType: 'race',
    categories: ['ゴースト', 'スケルトン'],
    tier: 'rare',
    description: '冥界から持ち帰られた神秘的な灯火。',
    icon: '🕯️',
  },

  // --- 爬虫類 ---
  snake_skin: {
    id: 'snake_skin',
    name: '蛇皮',
    group: 'reptile',
    groupType: 'race',
    categories: ['スネーク'],
    tier: 'uncommon',
    description: '蛇から剥がれ落ちた鱗の皮。柔軟な防具の素材。',
    icon: '🐍',
  },
  snake_king_fang: {
    id: 'snake_king_fang',
    name: '蛇王の牙',
    group: 'reptile',
    groupType: 'race',
    categories: ['スネーク'],
    tier: 'rare',
    description: '蛇の王から得られる猛毒の牙。',
    icon: '🦷',
  },

  // ========================================
  // 派閥系素材 (15グループ, 32素材)
  // ========================================

  // --- ソウルカース ---
  curse_chain: {
    id: 'curse_chain',
    name: '呪縛の鎖',
    group: 'soul_curse',
    groupType: 'faction',
    categories: ['ソウルカース'],
    tier: 'uncommon',
    description: '呪いを封じ込めた鎖。闇の力を秘める。',
    icon: '⛓️',
  },
  soul_eater_chain: {
    id: 'soul_eater_chain',
    name: '魂喰いの鎖',
    group: 'soul_curse',
    groupType: 'faction',
    categories: ['ソウルカース'],
    tier: 'rare',
    description: '魂を喰らう禍々しい鎖。非常に危険な素材。',
    icon: '💀',
  },

  // --- タイドウェーブ ---
  tide_crystal: {
    id: 'tide_crystal',
    name: '潮流の結晶',
    group: 'tide_wave',
    groupType: 'faction',
    categories: ['タイドウェーブ', 'マーメイド', 'リヴァイアサン'],
    tier: 'uncommon',
    description: '潮の流れが凝縮した結晶。水属性装備の素材。',
    icon: '🌊',
  },
  sea_god_tear: {
    id: 'sea_god_tear',
    name: '海神の涙',
    group: 'tide_wave',
    groupType: 'faction',
    categories: ['タイドウェーブ', 'マーメイド', 'リヴァイアサン'],
    tier: 'epic',
    description: '海神が流した涙の結晶。伝説級装備の素材。',
    icon: '🔱',
  },

  // --- パペットマスター ---
  puppet_thread: {
    id: 'puppet_thread',
    name: '操糸',
    group: 'puppet_master',
    groupType: 'faction',
    categories: ['パペットマスター'],
    tier: 'uncommon',
    description: '人形を操る糸。不思議な力を持つ。',
    icon: '🧵',
  },
  puppeteer_heart: {
    id: 'puppeteer_heart',
    name: '傀儡師の心臓',
    group: 'puppet_master',
    groupType: 'faction',
    categories: ['パペットマスター'],
    tier: 'rare',
    description: '傀儡師から得られる魔力を宿した心臓。',
    icon: '🎭',
  },

  // --- ダークドウェラ ---
  deep_darkness_shard: {
    id: 'deep_darkness_shard',
    name: '深闇の欠片',
    group: 'dark_dweller',
    groupType: 'faction',
    categories: ['ダークドウェラ', 'シャドウ'],
    tier: 'uncommon',
    description: '深い闇から生まれた欠片。闇属性装備の素材。',
    icon: '🌑',
  },
  abyss_core: {
    id: 'abyss_core',
    name: '深淵の核',
    group: 'dark_dweller',
    groupType: 'faction',
    categories: ['ダークドウェラ', 'シャドウ'],
    tier: 'rare',
    description: '深淵の中心から得られる核。',
    icon: '🕳️',
  },

  // --- マグマフォージ ---
  lava_core: {
    id: 'lava_core',
    name: '溶岩核',
    group: 'magma_forge',
    groupType: 'faction',
    categories: ['マグマフォージ'],
    tier: 'uncommon',
    description: '溶岩から生まれた熱い核。炎属性装備の素材。',
    icon: '🌋',
  },
  furnace_crystal: {
    id: 'furnace_crystal',
    name: '炉心の結晶',
    group: 'magma_forge',
    groupType: 'faction',
    categories: ['マグマフォージ'],
    tier: 'rare',
    description: '炉の中心で生成された希少な結晶。',
    icon: '🔥',
  },

  // --- 蛮族 ---
  savage_proof: {
    id: 'savage_proof',
    name: '蛮勇の証',
    group: 'barbarian',
    groupType: 'faction',
    categories: ['蛮族'],
    tier: 'uncommon',
    description: '蛮族の勇敢さを示す証。',
    icon: '💪',
  },
  chieftain_soul: {
    id: 'chieftain_soul',
    name: '族長の魂',
    group: 'barbarian',
    groupType: 'faction',
    categories: ['蛮族'],
    tier: 'rare',
    description: '蛮族の族長から得られる魂。',
    icon: '🪓',
  },

  // --- エクラシア ---
  time_gear: {
    id: 'time_gear',
    name: '時の歯車',
    group: 'eclasia',
    groupType: 'faction',
    categories: ['エクラシア', 'プリンセス'],
    tier: 'uncommon',
    description: '時を刻む神秘的な歯車。',
    icon: '⚙️',
  },
  eternal_sand: {
    id: 'eternal_sand',
    name: '永劫の砂',
    group: 'eclasia',
    groupType: 'faction',
    categories: ['エクラシア', 'プリンセス'],
    tier: 'rare',
    description: '永遠に流れ続ける砂。時空装備の素材。',
    icon: '⏳',
  },

  // --- 飛翔連合 ---
  sky_wing: {
    id: 'sky_wing',
    name: '天空の羽根',
    group: 'flying_union',
    groupType: 'faction',
    categories: ['スカイレジェンド', 'ウィング・トリビューン', 'フェニックス'],
    tier: 'uncommon',
    description: '天空を舞う者たちの羽根。',
    icon: '🪽',
  },
  azure_crown_feather: {
    id: 'azure_crown_feather',
    name: '蒼天の冠羽',
    group: 'flying_union',
    groupType: 'faction',
    categories: ['スカイレジェンド', 'ウィング・トリビューン'],
    tier: 'rare',
    description: '蒼い空を統べる者の冠羽。',
    icon: '👑',
  },
  phoenix_flame_feather: {
    id: 'phoenix_flame_feather',
    name: '不死鳥の炎羽',
    group: 'flying_union',
    groupType: 'faction',
    categories: ['フェニックス'],
    tier: 'epic',
    description: '不死鳥の炎を纏った羽根。蘇生の力を秘める。',
    icon: '🔥',
  },

  // --- 深淵勢力 ---
  abyss_fighting_spirit: {
    id: 'abyss_fighting_spirit',
    name: '深淵の闘気',
    group: 'abyss_force',
    groupType: 'faction',
    categories: ['アビスソウル', 'ディープシャドウ', 'デーモン', 'ブラック・オラクル'],
    tier: 'uncommon',
    description: '深淵に棲む者たちの闘気。',
    icon: '💢',
  },
  void_heart: {
    id: 'void_heart',
    name: '虚無の心臓',
    group: 'abyss_force',
    groupType: 'faction',
    categories: ['アビスソウル', 'ディープシャドウ', 'デーモン'],
    tier: 'rare',
    description: '虚無に染まった心臓。非常に危険な素材。',
    icon: '🖤',
  },
  prophecy_eye: {
    id: 'prophecy_eye',
    name: '預言の瞳',
    group: 'abyss_force',
    groupType: 'faction',
    categories: ['ブラック・オラクル'],
    tier: 'epic',
    description: '未来を見通す預言者の瞳。',
    icon: '👁️',
  },

  // --- 虚蝕 ---
  void_shard: {
    id: 'void_shard',
    name: '虚無の欠片',
    group: 'void_erosion',
    groupType: 'faction',
    categories: ['虚蝕'],
    tier: 'uncommon',
    description: '虚無から生まれた欠片。触れると力が吸われる。',
    icon: '⚫',
  },
  erosion_core: {
    id: 'erosion_core',
    name: '侵蝕の核',
    group: 'void_erosion',
    groupType: 'faction',
    categories: ['虚蝕'],
    tier: 'rare',
    description: '全てを侵蝕する力を持つ核。',
    icon: '🌀',
  },

  // --- 聖光 ---
  holy_light_crystal: {
    id: 'holy_light_crystal',
    name: '聖光の結晶',
    group: 'holy_light',
    groupType: 'faction',
    categories: ['ルミナフォース', '天使', 'エンジェル'],
    tier: 'uncommon',
    description: '聖なる光が凝縮した結晶。光属性装備の素材。',
    icon: '✨',
  },
  saint_prayer: {
    id: 'saint_prayer',
    name: '聖女の祈り',
    group: 'holy_light',
    groupType: 'faction',
    categories: ['ルミナフォース', '天使', 'エンジェル'],
    tier: 'rare',
    description: '聖女の祈りが込められた希少な素材。',
    icon: '🙏',
  },

  // --- 時空 ---
  spacetime_sand: {
    id: 'spacetime_sand',
    name: '時空の砂',
    group: 'spacetime',
    groupType: 'faction',
    categories: ['トラベラー'],
    tier: 'uncommon',
    description: '時空の狭間から集められた砂。',
    icon: '⌛',
  },
  dimension_key: {
    id: 'dimension_key',
    name: '次元の鍵',
    group: 'spacetime',
    groupType: 'faction',
    categories: ['トラベラー'],
    tier: 'rare',
    description: '異次元への扉を開く鍵。',
    icon: '🗝️',
  },

  // --- 毒牙 ---
  poison_gland: {
    id: 'poison_gland',
    name: '毒腺',
    group: 'poison_fang',
    groupType: 'faction',
    categories: ['ポイズンウェイル'],
    tier: 'uncommon',
    description: '毒を生成する腺。毒属性装備の素材。',
    icon: '☠️',
  },
  deadly_poison_heart: {
    id: 'deadly_poison_heart',
    name: '猛毒の心臓',
    group: 'poison_fang',
    groupType: 'faction',
    categories: ['ポイズンウェイル'],
    tier: 'rare',
    description: '猛毒を生み出す心臓。非常に危険。',
    icon: '💚',
  },

  // --- 拘束 ---
  chain_shard: {
    id: 'chain_shard',
    name: '鎖の欠片',
    group: 'restraint',
    groupType: 'faction',
    categories: ['鎖'],
    tier: 'uncommon',
    description: '拘束の力を持つ鎖の欠片。',
    icon: '🔗',
  },
  seal_chain: {
    id: 'seal_chain',
    name: '封印の鎖',
    group: 'restraint',
    groupType: 'faction',
    categories: ['鎖'],
    tier: 'rare',
    description: '強力な封印の力を持つ鎖。',
    icon: '⛓️',
  },

  // --- 宿敵 ---
  fighting_spirit_shard: {
    id: 'fighting_spirit_shard',
    name: '闘志の欠片',
    group: 'rival',
    groupType: 'faction',
    categories: ['ライバル'],
    tier: 'uncommon',
    description: 'ライバルとの戦いで生まれた闘志の欠片。',
    icon: '🔥',
  },
  destiny_proof: {
    id: 'destiny_proof',
    name: '宿命の証',
    group: 'rival',
    groupType: 'faction',
    categories: ['ライバル'],
    tier: 'rare',
    description: '宿敵との因縁を示す証。',
    icon: '⚡',
  },
};

/**
 * 汎用素材
 */
export const GENERIC_MATERIALS = {
  magic_core: {
    id: 'magic_core',
    name: '魔力の核',
    tier: 'common',
    description: '魔力が凝縮した核。あらゆる装備の基礎素材。',
    icon: '💠',
  },
  treasure_fragment: {
    id: 'treasure_fragment',
    name: '秘宝の欠片',
    tier: 'rare',
    description: '古代の秘宝の欠片。希少な素材。',
    icon: '💎',
  },
  memory_crystal: {
    id: 'memory_crystal',
    name: '記憶の結晶',
    tier: 'epic',
    description: '記憶が凝縮した結晶。ミラーダンジョンで入手。',
    icon: '🔮',
  },
  primordial_crystal: {
    id: 'primordial_crystal',
    name: '原初の結晶',
    tier: 'legendary',
    description: '世界の始まりから存在する結晶。最高級素材。',
    icon: '⭐',
  },
  gr_material: {
    id: 'gr_material',
    name: 'GR素材',
    tier: 'legendary',
    description: 'GR装備の作成に必要な超希少素材。',
    icon: '🌈',
  },
  twilight_fragment: {
    id: 'twilight_fragment',
    name: '黄昏の欠片',
    tier: 'epic',
    description: '光と闇が交わる境界で生まれた欠片。',
    icon: '🌅',
  },
  balance_stone: {
    id: 'balance_stone',
    name: '均衡の石',
    tier: 'epic',
    description: '全属性のバランスを司る石。',
    icon: '☯️',
  },
  forbidden_fragment: {
    id: 'forbidden_fragment',
    name: '禁忌の欠片',
    tier: 'legendary',
    description: '禁忌の力が宿った欠片。禁忌ダンジョンで入手。',
    icon: '⚠️',
  },
};

/**
 * 経験値オーブ
 */
export const EXP_ORB_MATERIALS = {
  exp_orb_small: {
    id: 'exp_orb_small',
    name: '経験値オーブ・小',
    tier: 'common',
    expValue: 100,
    baseCost: 300,
    description: '少量の経験値が凝縮したオーブ。モンスターの育成に使用。',
    icon: '🔵',
  },
  exp_orb_medium: {
    id: 'exp_orb_medium',
    name: '経験値オーブ・中',
    tier: 'uncommon',
    expValue: 500,
    baseCost: 1200,
    description: '中量の経験値が凝縮したオーブ。モンスターの育成に使用。',
    icon: '🟣',
  },
  exp_orb_large: {
    id: 'exp_orb_large',
    name: '経験値オーブ・大',
    tier: 'rare',
    expValue: 2000,
    baseCost: 4000,
    description: '大量の経験値が凝縮したオーブ。モンスターの育成に使用。',
    icon: '🟡',
  },
  exp_orb_super: {
    id: 'exp_orb_super',
    name: '経験値オーブ・超',
    tier: 'epic',
    expValue: 10000,
    baseCost: 15000,
    description: '膨大な経験値が凝縮した超希少オーブ。モンスターの育成に使用。',
    icon: '🌟',
  },
};

/**
 * 経験値オーブの使用コスト計算（レベル累進コスト）
 * @param {Object} orb - オーブ情報
 * @param {number} currentLevel - 現在のレベル
 * @returns {number} 使用に必要なゴールド
 */
export function calculateOrbUseCost(orb, currentLevel) {
  const baseCost = orb.baseCost || 0;
  const levelMultiplier = 1 + (currentLevel / 100);
  return Math.floor(baseCost * levelMultiplier);
}

/**
 * 経験値オーブをIDから取得
 */
export function getExpOrbById(orbId) {
  return EXP_ORB_MATERIALS[orbId] || null;
}

/**
 * 全経験値オーブを取得
 */
export function getAllExpOrbs() {
  return Object.values(EXP_ORB_MATERIALS);
}

/**
 * レアリティ破片
 */
export const RARITY_FRAGMENTS = {
  // 実際のレアリティシステム: C, UC, R, SR, UR, HR, SEC, ALT, SP, GR
  c_fragment: { id: 'c_fragment', name: 'C破片', rarity: 'C', tier: 'common', icon: '⬜' },
  uc_fragment: { id: 'uc_fragment', name: 'UC破片', rarity: 'UC', tier: 'common', icon: '🟩' },
  r_fragment: { id: 'r_fragment', name: 'R破片', rarity: 'R', tier: 'uncommon', icon: '🟦' },
  sr_fragment: { id: 'sr_fragment', name: 'SR破片', rarity: 'SR', tier: 'uncommon', icon: '🟪' },
  ur_fragment: { id: 'ur_fragment', name: 'UR破片', rarity: 'UR', tier: 'rare', icon: '🟧' },
  hr_fragment: { id: 'hr_fragment', name: 'HR破片', rarity: 'HR', tier: 'rare', icon: '🟨' },
  sec_fragment: { id: 'sec_fragment', name: 'SEC破片', rarity: 'SEC', tier: 'epic', icon: '🔴' },
  alt_fragment: { id: 'alt_fragment', name: 'ALT破片', rarity: 'ALT', tier: 'epic', icon: '💗' },
  sp_fragment: { id: 'sp_fragment', name: 'SP破片', rarity: 'SP', tier: 'legendary', icon: '💜' },
  gr_fragment: { id: 'gr_fragment', name: 'GR破片', rarity: 'GR', tier: 'legendary', icon: '🌈' },
};

/**
 * 素材名から素材情報を取得
 */
export function getMaterialInfo(materialName) {
  // 属性素材から検索
  for (const mat of Object.values(ATTRIBUTE_MATERIALS)) {
    if (mat.name === materialName) return mat;
  }

  // カテゴリ素材から検索
  for (const mat of Object.values(CATEGORY_MATERIALS)) {
    if (mat.name === materialName) return mat;
  }

  // 汎用素材から検索
  for (const mat of Object.values(GENERIC_MATERIALS)) {
    if (mat.name === materialName) return mat;
  }

  // 経験値オーブから検索
  for (const mat of Object.values(EXP_ORB_MATERIALS)) {
    if (mat.name === materialName) return mat;
  }

  // レアリティ破片から検索
  for (const mat of Object.values(RARITY_FRAGMENTS)) {
    if (mat.name === materialName) return mat;
  }

  return null;
}

/**
 * 素材をティア別にグループ化
 */
export function getMaterialsByTier() {
  const allMaterials = {
    ...ATTRIBUTE_MATERIALS,
    ...CATEGORY_MATERIALS,
    ...GENERIC_MATERIALS,
    ...EXP_ORB_MATERIALS,
    ...RARITY_FRAGMENTS,
  };

  const grouped = {
    common: [],
    uncommon: [],
    rare: [],
    epic: [],
    legendary: [],
  };

  for (const mat of Object.values(allMaterials)) {
    const tier = mat.tier || 'common';
    if (grouped[tier]) {
      grouped[tier].push(mat);
    }
  }

  return grouped;
}

/**
 * 属性から属性素材を取得
 */
export function getAttributeMaterial(attribute) {
  const attributeMap = {
    '炎': ATTRIBUTE_MATERIALS.fire_crystal,
    '水': ATTRIBUTE_MATERIALS.water_crystal,
    '光': ATTRIBUTE_MATERIALS.light_crystal,
    '闇': ATTRIBUTE_MATERIALS.dark_crystal,
    '原始': ATTRIBUTE_MATERIALS.primal_crystal,
    '未来': ATTRIBUTE_MATERIALS.future_crystal,
  };

  return attributeMap[attribute] || null;
}

export default {
  ATTRIBUTE_MATERIALS,
  CATEGORY_MATERIALS,
  GENERIC_MATERIALS,
  EXP_ORB_MATERIALS,
  RARITY_FRAGMENTS,
  getMaterialInfo,
  getMaterialsByTier,
  getAttributeMaterial,
  calculateOrbUseCost,
  getExpOrbById,
  getAllExpOrbs,
};
